import TradeInStore from './TradeInStore';
class TradeInRootStore {
    constructor(props) {
        this.mergeStoreState = (prevProps, props) => {
            this.tradeInStore.setLoggedIn(props.isLoggedIn);
            this.tradeInStore.setTranslate(props.translate);
        };
        this.tradeInStore = new TradeInStore(this, props);
    }
}
export default TradeInRootStore;
